import type { DataLayerEventType, GA4_EVENT, GA4EventType } from './types';

export const pushToDataLayer = (event: GA4_EVENT, params: GA4EventType): void => {
    if (typeof window === 'undefined') {
        return;
    }

    if (!window.dataLayer) {
        return;
    }

    const dataLayerEvent: DataLayerEventType = {
        event,
        ecommerce: {
            items: [params]
        }
    };

    window.dataLayer.push(dataLayerEvent);
};
